import { __assign, __rest } from "tslib";
import React from 'react';
var VeltCommentDialogOptionsDropdownContentDeleteThreadWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-options-dropdown-content-delete-thread-wireframe", __assign({}, remainingProps), children));
};
export default VeltCommentDialogOptionsDropdownContentDeleteThreadWireframe;
